var map = {
	"./up-icon-beginner.svg": "702c",
	"./up-icon-confirmation.svg": "e3ea",
	"./up-icon-level0.svg": "4699",
	"./up-icon-question.svg": "20be",
	"./up-icon-request.svg": "6664",
	"./up-icon-technicalproblem.svg": "cf66",
	"./up-icon-trouble.svg": "48c2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "403f";